<template>
  <div>
    <!-- 绘制围栏 -->
    <label  v-if="fenceStatu === 'edit'" class="title">{{$t('supervise.drawFence')}}:</label>
    <a-select class="content-sel" v-if="fenceStatu === 'edit'" :placeholder="$t('supervise.drawFence')" @change="selectedDrawMode">
      <a-select-option key="1">{{$t('supervise.drawByWheel')}}</a-select-option>
      <a-select-option key="2">{{$t('supervise.selectDistrict')}}</a-select-option>
    </a-select>
    <!-- 按行政区绘制围栏 -->
    <ProvinceSelec @provinceData="provinceData" :fenceStatus="fenceStatu" v-if="showProvinceSelect" :map="map" />
    <!-- 地图 -->
    <!-- <div :id="`map-${idName}-${random}`" class="map"></div> -->
    <ZXMap @getMap="getMap"/>
    <AutoComplete v-model="circle" v-if="showAutoComplete" @circleChange="circleChange" :map="map" />
  </div>
</template>
<script>
import ProvinceSelec from './ProvinceSelec'
import AutoComplete from '../BMapComponents/AutoComplete'
import ZXMap from './BMap'
import {notAllowedInFenceStyle, notAllowedOutFenceStyle} from '../../config/globalConfig'
import {transToBD09} from '../../utils/globalFunction'
export default {
  // ..
  components: {
    ProvinceSelec,
    ZXMap,
    AutoComplete
  },
  model: {
    prop: 'mapData',
    event: 'mapDataChange'
  },
  props: {
    mapData: {
      required: true,
      type: Object
    },
    fenceStatu: {
      default: 'show',
      type: String
    },
    opt: {
      required: false
    }
  },
  data () {
    return {
      random: 250,
      overlays: [],
      points: [],
      // 定义颜色样式
      styleOptions: {
        //边线颜色。
        strokeColor:"red",
        //填充颜色。当参数为空时，圆形将没有填充效果   
        fillColor:"red",
        //边线的宽度，以像素为单位    
        strokeWeight: 3,
        //边线透明度，取值范围0 - 1     
        strokeOpacity: 0.8,
        //填充的透明度，取值范围0 - 1	   
        fillOpacity: 0.6,
        //边线的样式，solid或dashed    
        strokeStyle: 'solid'
      },
      showProvinceSelect: false,
      map: null,
      showAutoComplete: false,
      circle: {}
    }
  },
  methods: {
    provinceData (drawData) {
      this.$emit('mapDataChange', drawData)
    },
    setFenceStyle () {
      if (this.opt == 1 ) {
        this.styleOptions = notAllowedInFenceStyle
      } else if (this.opt == 2) {
        this.styleOptions = notAllowedOutFenceStyle
      } else {
        this.styleOptions = notAllowedInFenceStyle
      }
    },
    // 用户选择修改围栏的方式
    selectedDrawMode (e) {
      // this.map.clearOverlays()
      if (e && e === '1') {
        this.showProvinceSelect = false
        this.drawFenceByWheel()
      } else {
        if (this.drawingManager) {
          // console.log(this.drawingManager)
          // 移除鼠标绘制的控件
          this.map.removeControl(this.control)
          // 清除覆盖物即是现有的围栏
          this.map.clearOverlays()
          this.overlays = []
          this.showAutoComplete = false
        }
        this.showProvinceSelect = true
      }
    },
    circleChange (data) {
      // console.log(data)
      if (this.overlays[0]) {
        // console.log(this.overlays[0])
        // console.log(this.circle)
        this.overlays[0].setCenter(this.circle.center)
        this.overlays[0].setRadius(this.circle.radius)
        // 圆
        let drawData = {
          type: 'circle',
          parameter: {
            points: [
              [
                {
                  lat: this.circle.center.lat,
                  lng: this.circle.center.lng
                }
              ]
            ],
            radius: this.circle.radius
          }
        }
        this.$emit('mapDataChange', drawData)
      }
    },
    // 手动绘制围栏
    drawFenceByWheel () {
      // 在手动绘制围栏的时候，会生成画图的控件，先捕获到这个控件，方便以后移除
      this.map.addEventListener('addcontrol', (ev) => {
        // console.log(ev)
        this.control = ev.target
      })
      // 1. 创建绘制工具
      //实例化鼠标绘制工具
      let drawingManager = new BMapLib.DrawingManager(this.map, {
          isOpen: true, //是否开启绘制模式
          enableDrawingTool: true, //是否显示工具栏
          drawingToolOptions: {
              anchor: BMAP_ANCHOR_TOP_LEFT, //位置
              offset: new BMap.Size(5, 5), //偏离值
              // 只能画圆，线条，多边形
              drawingModes: [
                BMAP_DRAWING_CIRCLE, 
                // BMAP_DRAWING_POLYLINE,
                BMAP_DRAWING_POLYGON
              ]
          },
          circleOptions: this.styleOptions, //圆的样式
          polylineOptions: this.styleOptions, //线的样式
          polygonOptions: this.styleOptions, //多边形的样式
      })
      this.drawingManager = drawingManager
      // console.log(this.mapData)
      // console.log(this.overlays)
      if (this.mapData.type === 'district') {
        this.map.clearOverlays()
      }
      // 如果初始围栏是圆形的话，且没有显示围栏数值的话就显示信息
      if (this.mapData.type === 'circle' && this.showAutoComplete === false) {
        // console.log('ok')  
        this.drawingManager.setDrawingMode(window.BMAP_DRAWING_CIRCLE)
        if (this.overlays.length === 0) {
          this.drawInitFence()
        }
        let overlay = this.overlays[0]
        this.showAutoComplete = true
        let geoc = new BMap.Geocoder()
        geoc.getLocation(overlay.getCenter(), (res) => {
          let address
          if (res.address !== '') {
            address = res.address
          } else if ((res.addressComponents.city !== '') && (res.addressComponents.country !== '')) {
            address = res.addressComponents.city + ', ' + res.addressComponents.country
          }
          this.circle.address = address
          this.circle.center = overlay.getCenter()
          this.circle.radius = Math.floor(overlay.getRadius())
          // console.log(this.circle)
          // this.$nextTick().then(() => {
            this.circle = {...this.circle}
          // })
        })
      }
      this.map && this.map.addEventListener('click', (ev) => {
        // console.log(ev)
        let drawType = this.drawingManager.getDrawingMode()
        // console.log(drawType)
        // 用户开始画圆或者点了圆心
        if (drawType === 'circle') {
          this.showAutoComplete = true
          // 只点了一个点
          // 1、解析出中心点，显示出来，是否联想周边地区
          // 2、 此时用户可以选择-自定义设置圆形围栏的半径-m
          // 3、 设置之后画出圆形围栏
          // 4、 是否修改
        } else {
          // 取消选择框之类的组件
          this.showAutoComplete = false
        }
      })
      this.drawingManager.addEventListener('circlecomplete', (ev) => {
        // console.log('complete')
        let geoc = new BMap.Geocoder()
        geoc.getLocation(point, (res) => {
          let address
          if (res.address !== '') {
            address = res.address
          } else if ((res.addressComponents.city !== '') && (res.addressComponents.country !== '')) {
            address = res.addressComponents.city + ', ' + res.addressComponents.country
          }
          this.circle.address = address
          this.circle.center = ev.getCenter()
          this.circle.radius = Math.floor(ev.getRadius())
          // console.log(this.circle)
          // this.$nextTick().then(() => {
            this.circle = {...this.circle}
          // })
          this.drawingManager.close()
        })
      })
      // 添加鼠标绘制工具监听事件，用于获取绘制结果
      this.drawingManager.addEventListener('overlaycomplete', (ev) => {
        // console.log(ev)
        // 获取画的图形数据
        // map上只能有一个overlay
        if (this.overlays.length === 0) {
          this.overlays.push(ev.overlay)
        } else {
          this.map.removeOverlay(this.overlays[0])
          this.overlays = []
          // this.map.clearOverlays()
          this.overlays.push(ev.overlay)
        }
        let drawData
        if (ev && ev.drawingMode === 'circle') {
          if (this.showAutoComplete === false) {
            this.showAutoComplete = true
          }
          // 圆
          // console.log(ev.overlay.getCenter())
          // console.log(ev.overlay.getRadius())
          drawData = {
            type: ev.drawingMode,
            parameter: {
              points: [
                [
                  {
                    lat: ev.overlay.point.lat,
                    lng: ev.overlay.point.lng
                  }
                ]
              ],
              radius: ev.overlay.getRadius()
            },
          }
        } else {
          this.showAutoComplete = false
          // 其他图形
          // console.log(ev.overlay.getPath())
          let path = ev.overlay.getPath()
          path.push(path[0])
          drawData = {
            type: ev.drawingMode,
            parameter: {
              points: [
                path
              ]
            }
          }
        }
        // console.log(drawData)
        this.drawingManager.close()
        // 发送事件通知数据改变了,需要一个围栏id，才能使得父级组件知道改变的是哪一个围栏
        this.$emit('mapDataChange', drawData)
      })
    },
    // 绘制图形
    drawPattern (type) {
      if (type) {

        let pattern = {
          'polygon': () => {
            // 获取所有点坐标
            let points = []
            // console.log(this.mapData.parameter)
            for (let i = 0; i < this.mapData.parameter.points[0].length; i++) {
              points.push(new BMap.Point(...this.formatMapPoint(this.mapData.parameter.points[0][i])))
            }
            // console.log(points)
            let polygon = new BMap.Polygon(points, this.styleOptions)
            this.points = points
            return polygon
          },
          'district': () => {
            let points = []
            let overlays = []
            // console.log(this.mapData)
            for (let i = 0; i < this.mapData.parameter.points.length; i++) {
              // 为解决行政区可能有多个区域，需先定义每个坐标容器 []
              // 当然也可以用 points[i] = [...points[i], new xxxxxxxxx]这样的思路解决问题
              points[i] = []
              for (let j = 0; j < this.mapData.parameter.points[i].length; j++) {
                // debugger
                points[i].push(new BMap.Point(...this.formatMapPoint(this.mapData.parameter.points[i][j])))
              }
              this.points = [...this.points, ...points[i]]
              overlays.push(new BMap.Polygon(points[i], this.styleOptions))
            }
            // console.log(this.points)
            // console.log(overlays)
            // let polygon = new BMap.Polygon(points[i], this.styleOptions)
            return overlays
          },
          'circle': () => {
            let center = new BMap.Point(...this.getMapCenterPoint())
            // console.log(center)
            // console.log(this.mapData)
            let circle = new BMap.Circle(center, this.mapData.parameter.radius, this.styleOptions)
            // console.log(circle)
            let points = []
            let radius = this.mapData.parameter.radius
            points.push({lat:center.lat + radius/100000,lng:center.lng})
            points.push({lat:center.lat - radius/100000,lng:center.lng})
            points.push({lat:center.lat,lng:center.lng + radius/100000})
            points.push({lat:center.lat,lng:center.lng - radius/100000})
            this.points = points
            return circle
          }
          // 'polyline': () => {
          //   // 获取所有点坐标
          //   let points = []
          //   for (let i = 0; i < this.mapData.parameter.points[0].length; i++) {
          //     points.push(new BMap.Point(...this.formatMapPoint(this.mapData.parameter.points[0][i])))
          //   }
          //   let polyline = new BMap.Polyline(points, this.styleOptions)
          //   this.points = points 
          //   return polyline
          // }
        }
        return pattern[type]()
      }
    },
    // 初始化时绘制围栏
    drawInitFence () {
      // 绘制图形
      if (this.mapData.parameter) {
        
        // console.log(this.points)
        // console.log(this.map.getViewport(this.points))
        this.$nextTick().then(() => {
          let overlay = this.drawPattern(this.mapData.type)
          if (this.mapData.type === 'district') {
            for (let i = 0; i < overlay.length; i++) {
              this.map.addOverlay(overlay[i])
              this.overlays.push(overlay[i])
            }
          } else {
            this.map.addOverlay(overlay)
            this.overlays.push(overlay)
          }
          console.log(this.points)
          console.log(this.map)
          this.map.setViewport(this.points)
        })
        // this.testLushu()
        // console.log(overlay)
      }
    },
    // {lat: 232, lng: 35} ==> [232, 35]
    formatMapPoint (point) {
      return [point.lng, point.lat]
    },
    // 获取创建地图的中心点坐标
    getMapCenterPoint () {
      // console.log(this.mapData)
      if (this.mapData) {
        // 圆和其他类型需分开处理
        if (this.mapData.type === 'circle') {
          // console.log(this.mapData.parameter.points[0][0])
          return [this.mapData.parameter.points[0][0].lng, this.mapData.parameter.points[0][0].lat]
        } else {
          // ...
          // console.log(this.mapData)
          // debugger
          let latSum = 0
          let lngSum = 0
          for (let i = 0; i < this.mapData.parameter.points[0].length; i++) {
            latSum += this.mapData.parameter.points[0][i].lat
            lngSum += this.mapData.parameter.points[0][i].lng
          }
          let center = [(lngSum / this.mapData.parameter.points[0].length).toFixed(6), (latSum / this.mapData.parameter.points[0].length).toFixed(6)]
          // console.log(center)
          return center
        }
      }
    },
    // 创建地图
    // createMap () {
    //   // console.log(1111111)
    //   if (document.getElementById(`map-${this.idName}-${this.random}`)) {
    //     // 创建地图实例
    //     this.map = new BMap.Map(`map-${this.idName}-${this.random}`)
    //     // 创建点坐标
    //     // console.log(...this.getMapCenterPoint())
    //     let point = new BMap.Point(...this.getMapCenterPoint())
    //     // console.log(point)
    //     // 初始化地图，设置中心点坐标和地图级别
    //     this.map.centerAndZoom(point, 12)
    //     // 可以使用鼠标缩放地图
    //     this.map.enableScrollWheelZoom(true)
    //     // this.map = map
    //     // 绘制初始的电子围栏图形
    //     // console.log(this.mapData)
    //     this.drawInitFence()
    //   }
    // },
    getMap (map) {
      this.map = map
      this.drawInitFence()
    },
    createMapToolInstance () {
      //实例化鼠标绘制工具
      let drawingManager = new BMapLib.DrawingManager(this.map, {
          isOpen: false, //是否开启绘制模式
          enableDrawingTool: true, //是否显示工具栏
          drawingToolOptions: {
              anchor: BMAP_ANCHOR_TOP_LEFT, //位置
              offset: new BMap.Size(5, 5), //偏离值
              // 只能画圆，线条，多边形
              drawingModes: [
                BMAP_DRAWING_CIRCLE, 
                // BMAP_DRAWING_POLYLINE,
                BMAP_DRAWING_POLYGON
              ]
          },
          circleOptions: this.styleOptions, //圆的样式
          polylineOptions: this.styleOptions, //线的样式
          polygonOptions: this.styleOptions, //多边形的样式
      })
      this.drawingManager = drawingManager
    },
    transPoints () {
      if (this.mapData.coordType) {
        this.mapData.parameter.points.forEach((pointsItem, i) => {
          pointsItem.forEach((point, j) => {
            let transedPoint = transToBD09(this.mapData.coordType, point.lng, point.lat)
            this.mapData.parameter.points[i][j].lng = transedPoint.lng
            this.mapData.parameter.points[i][j].lat = transedPoint.lat
          })
        })
        this.mapData.coordType = 'bd09'
        console.log(this.mapData)
      }
    }
  },
  mounted () {
    // this.createMap()
    // this.createMapToolInstance()
  },
  created () {
    // this.random = Math.floor(Math.random() * 100000)
    // this.opt == 1 ? notAllowedInFenceStyle : notAllowedOutFenceStyle
    this.setFenceStyle()
    this.transPoints()
  }
}
</script>
<style lang="less" scoped>
@import '../../theme/color.less';
.map {
  width: 100%;
  height: 40vh;
}
.title {
  margin-right: 10px;
  margin-left: 5px;
  color: @heading-color;
}
.content-sel {
  width: 270px;
  margin: 5px 0;
  // display: block;
}
</style>
